var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1837 1.31162C13.5992 0.896126 14.2729 0.896125 14.6884 1.31162C15.1039 1.72712 15.1039 2.40078 14.6884 2.81627L9.50464 8L14.6884 13.1837C15.1039 13.5992 15.1039 14.2729 14.6884 14.6884C14.2729 15.1039 13.5992 15.1039 13.1837 14.6884L7.99999 9.50465L2.81627 14.6884C2.40078 15.1039 1.72712 15.1039 1.31162 14.6884C0.896125 14.2729 0.896126 13.5992 1.31162 13.1837L6.49534 8L1.31162 2.81629C0.896126 2.40079 0.896125 1.72714 1.31162 1.31164C1.72712 0.896141 2.40078 0.896141 2.81627 1.31164L7.99999 6.49535L13.1837 1.31162Z",
    fill: "#2D2D2D",
    stroke: "#2D2D2D",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c4468d6f630df2cf31d0964838d8ba75.svg";
export { ForwardRef as ReactComponent };